import { LinkType } from '@dtx-company/flow-codegen/src/page/typeUtils'
import { Maybe } from '@dtx-company/flow-codegen/src/page/generated.types'

export const getFBPixelLinks = (links: Maybe<LinkType>[]): Maybe<LinkType>[] =>
  links?.filter(link => link?.provider === 'widget' && link?.type === 'fbPixel')
